<Picture src={url} {...computedPicture}>

    <div slot="overlay" class="text text--align-right">

        <a title="Source" class="light" href={url}>
            
            <Icon iconId="enlarge" />
        
        </a>

    </div>

</Picture>

<script>
    import Icon from 'components/Icon.html'
    import Picture from 'components/Picture.html'
    
    export default {
        components: {
            Picture,
            Icon
        },
        computed: {
            computedPicture: ({ picture }) => {
                return {
                    fit: "cover",
                    format: "hd",
                    scale: 1,
                    behaviour: "reveal",
                    ...picture
                }
            }
        },
        data() {
            return {
                url: '',
                picture: {}
            }
        }
    }
</script>